import { useServices } from "contexts/ServiceContext";
import { useRouter } from "next/router";
import { useCallback } from "react";

const useCloseProfileMenu = () => {
    const router = useRouter();
    const services = useServices();

    return useCallback(() => {
        services.NavigationService.CloseProfileMenu(router.asPath, router.pathname, router.query, {
            shallow: true,
        });
    }, [router.asPath, router.pathname, router.query, services.NavigationService]);
};

export default useCloseProfileMenu;
